import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const GenerationDisabledTooltip = ({
  children,
  contentAssistanceEnabled,
  isGenerationDisabled,
  tooltipTitle,
  tooltipProps
}) => {
  const settingsLink = `/ai-settings/${PortalIdParser.get()}?source=image-gen`;
  const tooltipTranslationKey = 'fileManager.imageGen.generateDisabledTooltip_jsx';
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    disabled: Boolean(contentAssistanceEnabled) && !isGenerationDisabled,
    title: tooltipTitle || /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: tooltipTranslationKey,
      elements: {
        UILink
      },
      options: {
        settingsLink
      }
    }),
    maxInlineSize: "250px"
  }, tooltipProps, {
    children: children
  }));
};
export default GenerationDisabledTooltip;